import {
  type UpdateTransportRequestOnrApiMutationOptions,
  useUpdateTransportRequestOnrApi,
} from './mutation/useUpdateTransportRequestOnrApi.ts'

export interface ReactivateTransportRequestApiVariables {
  regionId: string
  transportRequestId: string
}

export const useReactivateTransportRequest = (
  options?: UpdateTransportRequestOnrApiMutationOptions<void, ReactivateTransportRequestApiVariables>
) =>
  useUpdateTransportRequestOnrApi<void, ReactivateTransportRequestApiVariables>({
    type: 'piloteReactivateTransportRequest',
    ...options,
  })
